import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ff-component-library-angular',
  template: `
    <p>
      ff component-library-angular works!
    </p>
  `,
  styles: [
  ]
})
export class ComponentLibraryAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
